import { FullTasksFormSchema } from 'features/Work/form/tasksForm.schema';
import { InvoiceTaskWithoutTotal } from 'features/Work/types';

export const formatInvoiceTask = (
  task: FullTasksFormSchema,
  index: number,
): InvoiceTaskWithoutTotal => ({ ...task, taskOrder: index });
